/* tslint:disable:max-classes-per-file */
import { Action } from '@ngrx/store';

export const NO_OP = 'NO_OP';

export class NoOpAction implements Action {
  public readonly type = NO_OP;
}

export type Actions = NoOpAction;
